import { createActionTypes } from 'redux/utils/actionUtils';

export const type = 'NOTIFICATION';

const actionTypes = [
  type + '_EDITOR_UPDATE',
  type + '_EDITOR_HIDE'
];

export default createActionTypes(actionTypes);



/** WEBPACK FOOTER **
 ** ./src/redux/modules/notification/notificationActionType.js
 **/